
/** Keyboard input ENUM */
export enum KeyboardInput {
    // Macro buttons
    ALT = "Alt",
    ALT_GRAPH = "AltGraph",
    TAB = "Tab",
    CTRL = "Control",
    SHIFT = "Shift",
    ESCAPE = "Escape",
    ENTER = "Enter",
    PAGE_DOWN = "PageDown",
    PAGE_UP = "PageUp",
    BACKSPACE = "Backspace",
    DELETE = "Delete",
    NUM_LOCK = "NumLock",
    SCROLL_LOCK = "ScrollLock",
    CAPS_LOCK = "CapsLock",
    INSERT = "Insert",
    PAUSE = "Pause",
    PRINT_SCREEN = "PrintScreen",
    CONTEXT_MENU = "ContextMenu",
    HOME = "Home",
    END = "End",
    SPACE = " ",
    META = "Meta",
    CLEAR = "Clear",    // F keys
    F1 = "F1",
    F2 = "F2",
    F3 = "F3",
    F4 = "F4",
    F5 = "F5",
    F6 = "F6",
    F7 = "F7",
    F8 = "F8",
    F9 = "F9",
    F10 = "F10",
    F11 = "F11",
    F12 = "F12",
    // Symbol
    AMPERSAND = "&",
    É = "é",
    È = "è",
    DOUBLE_QUOTE = "\"",
    QUOTE = "'",
    PARENTHESIS_LEFT = "(",
    PARENTHESIS_RIGHT = ")",
    DASH = "-",
    UNDERSCORE = "_",
    C_CEDILLA = "ç",
    À = "à",
    EQUAL = "=",
    DEGREE = "°",
    PLUS = "+",
    TILDE = "~",
    SHARP = "#",
    BRACE_LEFT = "{",
    BRACE_RIGHT = "}",
    BRACKET_LEFT = "[",
    BRACKET_RIGHT = "]",
    PIPE = "|",
    BACK_QUOTE = "Dead",
    BACKSLASH = "\\",
    SLASH = "/",
    CIRCUMFLEX = "^",
    AROBASE = "@",
    ASTERISK = "*",
    QUESTION_MARK = "?",
    COMMA = ",",
    DOT = ".",
    SEMICOLON = ";",
    COLON = ":",
    SECTION = "§",
    EXCLAMATION_MARK = "!",
    POURCENT = "%",
    Ù = "ù",
    MICRO = "µ",
    DOLLAR = "$",
    LIVRE = "£",
    LEFT_ANGLE_BRACKETS = "<",
    RIGHT_ANGLE_BRACKETS = ">",
    SQUARED = "²",
    // Arrows
    ARROW_DOWN = "ArrowDown",
    ARROW_LEFT = "ArrowLeft",
    ARROW_RIGHT = "ArrowRight",
    ARROW_UP = "ArrowUp",
    // Numbers
    NUM_0 = "0",
    NUM_1 = "1",
    NUM_2 = "2",
    NUM_3 = "3",
    NUM_4 = "4",
    NUM_5 = "5",
    NUM_6 = "6",
    NUM_7 = "7",
    NUM_8 = "8",
    NUM_9 = "9",
    // Letters
    A = "a",
    B = "b",
    C = "c",
    D = "d",
    E = "e",
    F = "f",
    G = "g",
    H = "h",
    I = "i",
    J = "j",
    K = "k",
    L = "l",
    M = "m",
    N = "n",
    O = "o",
    P = "p",
    Q = "q",
    R = "r",
    S = "s",
    T = "t",
    U = "u",
    V = "v",
    W = "w",
    X = "x",
    Y = "y",
    Z = "z",
    // Letters CAPS
    A_CAPS = "A",
    B_CAPS = "B",
    C_CAPS = "C",
    D_CAPS = "D",
    E_CAPS = "E",
    F_CAPS = "F",
    G_CAPS = "G",
    H_CAPS = "H",
    I_CAPS = "I",
    J_CAPS = "J",
    K_CAPS = "K",
    L_CAPS = "L",
    M_CAPS = "M",
    N_CAPS = "N",
    O_CAPS = "O",
    P_CAPS = "P",
    Q_CAPS = "Q",
    R_CAPS = "R",
    S_CAPS = "S",
    T_CAPS = "T",
    U_CAPS = "U",
    V_CAPS = "V",
    W_CAPS = "W",
    X_CAPS = "X",
    Y_CAPS = "Y",
    Z_CAPS = "Z"
}

export type KeyboardPressed = Record<KeyboardInput, boolean>;

/** List of keyboard input arrows */
export const KEYBOARD_INPUT_ARROWS = [
    KeyboardInput.ARROW_UP,
    KeyboardInput.ARROW_DOWN,
    KeyboardInput.ARROW_LEFT,
    KeyboardInput.ARROW_RIGHT
];
